import React from 'react'
import { useTranslation } from 'react-i18next'

import { CardTemplate } from '../../../../components/CardTemplate'
import { PanelContainer } from '../../../../components/Panel'
import { useConfigContext } from '../../../ui-config'
import { useDeliveryForecastById } from '../../data'

type Props = {
  deliveryForecastId: string
}

export const Header: React.FC<Props> = ({ deliveryForecastId }) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()
  const { data, isLoading } = useDeliveryForecastById(deliveryForecastId)

  const newShippingInformation = {
    ...data?.Payload.RecipientInformation,
    Plant: data?.Payload.Items?.[0].Plant,
    UnloadingPoint: data?.Payload.Items?.[0].UnloadingPoint,
  }

  return (
    <PanelContainer
      header={t('deliveryForecast.header.title')}
      id="delivery-call-offs-header"
      visible={config.deliveryForecast.header.enabled}
    >
      <div className="grid">
        {/* buyer */}
        <CardTemplate
          title={t('deliveryForecast.header.buyerInformation.title')}
          data={data?.Payload.BuyerInformation}
          config={config.deliveryForecast.header.buyerInformation}
          isLoading={isLoading}
        />

        {/* seller */}
        <CardTemplate
          title={t('deliveryForecast.header.sellerInformation.title')}
          data={data?.Payload.SellerInformation}
          config={config.deliveryForecast.header.sellerInformation}
          isLoading={isLoading}
        />

        {/* shipping */}
        <CardTemplate
          title={t('deliveryForecast.header.shippingInformation.title')}
          data={newShippingInformation}
          config={config.deliveryForecast.header.shippingInformation}
          isLoading={isLoading}
        />
      </div>
    </PanelContainer>
  )
}
